import * as React from 'react'
import { castingStoreFormatSelectedOption, castingStoreGetSelectedOptionJoined, castingStoreIsOfferedOptionMandatory, StoreProps } from '../../../../services/stores/casting.store'

type Props = StoreProps & { className?: string }

export default function CastingOptionsListTagComponent ({ store, className, data, data: { selectedOptions, castingType } }: Props) {
  return <ul className={ `listTag ${ className || '' }` }>
    { castingStoreGetSelectedOptionJoined(data).map((so, index) => {
      const required = so.offeredOption.option_type === 'product_catalogue'
        ? so.offeredOptionOfferedService.required_status !== 'no_required'
        : castingStoreIsOfferedOptionMandatory(so.offeredOption, castingType)

      return <li key={ index } className={ `listTag-element ${ required ? '' : 'with-close' }` }>
        { so.offeredOption.option_type === 'product_catalogue' ? so.offeredOptionOfferedService.offered_service.name : so.offeredOption.name }

        <span className="listTag-element-extra">{ castingStoreFormatSelectedOption(data, so) }</span>

        { !required && <button onClick={ () => store.set({ selectedOptions: selectedOptions.filter(_ => _ !== so.selectedOption) }) } className="listTag-close">
          <i className="icon icon-close"></i>
        </button> }
      </li>
    }) }
  </ul>
}
